import 'rxjs/add/operator/map'
import { switchMap } from 'rxjs/operators'
import { ActivatedRoute, Router } from '@angular/router'
import { AngularFireAuth } from '@angular/fire/auth'
import { Injectable, EventEmitter, NgZone } from '@angular/core'
import firebase from 'firebase/app'
import 'firebase/auth'
import { Observable, of } from 'rxjs'
import { AppUser } from '../models/app-user.model'
import { UserService } from './user.service'
import { User } from 'firebase'
import { RouteNames } from '../const/route/route-names.model'

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  userLoggedinEvent: EventEmitter<boolean> = new EventEmitter<boolean>()
  user$: Observable<firebase.User>
  appUser: AppUser

  constructor(
    private userService: UserService,
    private afAuth: AngularFireAuth,
    private route: ActivatedRoute,
    private router: Router,
    private ngZone: NgZone
  ) {
    this.user$ = afAuth.authState
    firebase.auth().onAuthStateChanged((user: User) => {
      this.ngZone.run(() => {
        if (user) {
          this.updateAppUser(user)
          this.router.navigate(['/' + RouteNames.PATH_EVENT])
        } else {
          this.appUser = null
          this.userLoggedinEvent.emit(false)
        }
      })
    })
  }

  private updateAppUser(user: firebase.User) {
    this.userService.get(user.uid).subscribe((appUser: AppUser) => {
      this.appUser = appUser
      this.userLoggedinEvent.emit(true)
    })
  }

  login() {
    const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') || '/'
    localStorage.setItem('returnUrl', returnUrl)
  }

  isLoggedIn(): boolean {
    return this.appUser ? true : false
  }

  signInWithGoogle() {
    let provider = new firebase.auth.GoogleAuthProvider()
    firebase
      .auth()
      .signInWithPopup(provider)
      .then(result => {
        let credential = result.credential
        let user = result.user
      })
      .catch(error => {
        let errorCode = error.code
        let errorMessage = error.message
        let email = error.email
        let credential = error.credential
      })
  }

  signInWithEmailAndPassword(email: string, password: string) {
    return this.afAuth.signInWithEmailAndPassword(email, password)
  }

  createUserWithEmailAndPassword(name: string, email: string, password: string) {
    return this.afAuth.createUserWithEmailAndPassword(email, password).then(cred => {
      if (cred.user) {
        return cred.user.updateProfile({ displayName: name }).then(() => {
          this.userService.save(cred.user)
          return cred
        })
      }
      return cred
    })
  }

  logout() {
    this.afAuth.signOut()
    this.router.navigate(['/login'])
  }

  getCurrentUser(): AppUser {
    return this.appUser
  }

  get appUser$(): Observable<AppUser> {
    return this.user$.pipe(
      switchMap((user: firebase.User) => {
        if (user) {
          return this.userService.get(user.uid)
        }
        return of(null)
      })
    )
  }

  // New methods for password reset
  sendPasswordResetEmail(email: string, url: string): Promise<void> {
    return this.afAuth.sendPasswordResetEmail(email, { url: url })
  }

  verifyPasswordResetCode(oobCode: string): Promise<string> {
    return firebase.auth().verifyPasswordResetCode(oobCode)
  }

  confirmPasswordReset(oobCode: string, newPassword: string): Promise<void> {
    return this.afAuth.confirmPasswordReset(oobCode, newPassword)
  }
}
